import { Container, Row, Tab, Col, Nav } from "react-bootstrap";
import { motion } from "framer-motion";
import { ProjectCard } from "./ProjectCards";
import colorSharp2 from "../assets/img/color-sharp2.png";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/projImg4.png";
import 'animate.css';

export const Projects = () => {
    const projects = [
        {
            title: "Hotel Booking Website",
            description: "Full-stack booking platform with real-time availability",
            imgUrl: projImg1,
            url: "https://your-hotel-website.vercel.app/",
            category: "web",
        },
        {
            title: "Virtual Assistant Portfolio",
            description: "Personal brand site for a professional VA",
            imgUrl: projImg2,
            url: "https://va-damilolaolatunji.vercel.app/",
            category: "design",
        },
        {
            title: "Product Showcase Website",
            description: "High-conversion product landing page — Tailwind CSS",
            imgUrl: projImg3,
            url: "https://tailwind-css-page-48q4.vercel.app/",
            category: "web",
        },
        {
            title: "Oasis Cleaning Website",
            description: "Service business site with booking & SEO optimisation",
            imgUrl: projImg4,
            url: "https://cleaning-serivce-website.vercel.app/",
            category: "web",
        },
    ];

    const webProjects = projects.filter(p => p.category === "web");
    const designProjects = projects.filter(p => p.category === "design");

    const fadeUp = {
        hidden: { opacity: 0, y: 28 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] } },
    };

    const stagger = {
        hidden: {},
        visible: { transition: { staggerChildren: 0.12 } },
    };

    const CardGrid = ({ items }) => (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            variants={stagger}
        >
            <Row>
                {items.map((project, index) => (
                    <motion.div
                        key={index}
                        className="col-sm-6 col-md-4"
                        variants={fadeUp}
                    >
                        <ProjectCard {...project} />
                    </motion.div>
                ))}
            </Row>
        </motion.div>
    );

    return (
        <section className="project" id="project">
            <Container>
                <Row>
                    <Col>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, margin: "-80px" }}
                            variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.12 } } }}
                        >
                            <motion.span className="section-tag" variants={fadeUp}>My Work</motion.span>
                            <motion.h2 variants={fadeUp}>Featured Projects</motion.h2>
                            <motion.p className="section-subtitle" variants={fadeUp}>
                                A selection of projects built with care — each one crafted to deliver
                                real results for real people.
                            </motion.p>
                        </motion.div>

                        <Tab.Container id="projects-tabs" defaultActiveKey="first">
                            <div className="tab-pills-wrapper">
                                <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">All Projects</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="second">Web Development</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="third">Design & Marketing</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>

                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <CardGrid items={projects} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <CardGrid items={webProjects} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                    <CardGrid items={designProjects} />
                                    <p style={{ textAlign: "center", color: "#666", fontStyle: "italic", marginTop: "32px", fontSize: "14px" }}>
                                        More design &amp; marketing projects coming soon...
                                    </p>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2} alt="" aria-hidden="true" />
        </section>
    );
};
